import { render, staticRenderFns } from "./notification-bell.vue?vue&type=template&id=51622b6a"
import script from "./notification-bell.vue?vue&type=script&lang=js"
export * from "./notification-bell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51622b6a')) {
      api.createRecord('51622b6a', component.options)
    } else {
      api.reload('51622b6a', component.options)
    }
    module.hot.accept("./notification-bell.vue?vue&type=template&id=51622b6a", function () {
      api.rerender('51622b6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/notification-bell.vue"
export default component.exports